"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoIspTargetingResponseToJSON = exports.GeoIspTargetingResponseFromJSONTyped = exports.GeoIspTargetingResponseFromJSON = exports.instanceOfGeoIspTargetingResponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the GeoIspTargetingResponse interface.
 */
function instanceOfGeoIspTargetingResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGeoIspTargetingResponse = instanceOfGeoIspTargetingResponse;
function GeoIspTargetingResponseFromJSON(json) {
    return GeoIspTargetingResponseFromJSONTyped(json, false);
}
exports.GeoIspTargetingResponseFromJSON = GeoIspTargetingResponseFromJSON;
function GeoIspTargetingResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'countryCode': !(0, runtime_1.exists)(json, 'country_code') ? undefined : json['country_code'],
        'isps': !(0, runtime_1.exists)(json, 'isps') ? undefined : json['isps'],
    };
}
exports.GeoIspTargetingResponseFromJSONTyped = GeoIspTargetingResponseFromJSONTyped;
function GeoIspTargetingResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'country_code': value.countryCode,
        'isps': value.isps,
    };
}
exports.GeoIspTargetingResponseToJSON = GeoIspTargetingResponseToJSON;
